import type { SupportedLocale } from '@/shared/types/i18n';

export const supportedLocales: readonly SupportedLocale[] = ['en', 'es', 'th', 'zh'];
export const defaultLocale: SupportedLocale = 'en';

export const localeLabels: Record<SupportedLocale, string> = {
  en: 'English',
  es: 'Español',
  th: 'ไทย',
  zh: '中文',
};

interface LocaleFontConfig {
  family: string;
  stylesheetUrl: string;
}

export const localeFontConfig = {
  en: {
    family: 'Noto Sans',
    stylesheetUrl:
      'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400..800&display=optional',
  },
  es: {
    family: 'Noto Sans',
    stylesheetUrl:
      'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400..800&display=optional',
  },
  th: {
    family: 'Noto Sans Thai',
    stylesheetUrl:
      'https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@400..800&display=optional',
  },
  zh: {
    family: 'Noto Sans SC',
    stylesheetUrl:
      'https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400..800&display=optional',
  },
} as const satisfies Record<SupportedLocale, LocaleFontConfig>;

export const localeFontFamilyProperty = '--locale-font-family';
export const localeFontStylesheetId = 'locale-font-stylesheet';
